module.exports = __webpack_public_path__ + "6dcb91b75d8e8ac33ed6d971faab30eb.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/logo.png
// module id = 17
// module chunks = 30